// extracted by mini-css-extract-plugin
export default {"star":"star_star__TeL0Z"};